import { State } from 'app/gamma/src/modules/types';

export const getCollapsedDrawerSections = (state: State) =>
  state.ui.collapsibles;
